export const iconList = [
  'bubble-plot',
  'building',
  'touchscreen',
  'engagement',
  'governance',
  'survey',
  'partership',
  'labs',
  'change',
  'speedometer',
  'bar-chart',
  'bridgechart',
  'spark-line',
  'pie-chart',
  'powerbi',
  'globe',
  'grow-revenue',
  'gantt_chart',
  'dial_high',
  'dashboard',
  'analysis',
  'savings1',
  'spider-chart',
  'kpi',
];
